import React, { useState } from 'react'
import PageWrapper from '../Components/Other/PageWrapper'
import PageBanner from '../Components/Other/PageBanner'
function NutritionAndWellness(props) {
const [tab,setTab]=useState(1)
    return (

        <PageWrapper className={"index-page"}>

            <div className="pageWrapper">
                <div className="web-sect pageBox">
                <PageBanner pageName={"Nutrition and Wellness"}></PageBanner>
                </div>
                <div className="MainContent">
                    <div className="container">
                        <div className="page-rte">
                            <div className="n_tab__title">
                                
                                <button className={`n_tab__button ${tab==1&&"n_tab_button-active"}`} onClick={()=>setTab(1)}>
                                    Balance diet
                                </button>
                                <button className={`n_tab__button ${tab==2&&"n_tab_button-active"}`}  onClick={()=>setTab(2)}>Body mass index</button>
                                <button className={`n_tab__button ${tab==3&&"n_tab_button-active"}`}  onClick={()=>setTab(3)}>Vitamins &amp; minerals</button>
                                <button className={`n_tab__button ${tab==4&&"n_tab_button-active"}`}  onClick={()=>setTab(4)}>Organs</button>
                            </div>
                           { tab==1?<div id="balance_diet" className="nutrition_cont balance_diet">
                                <h2>
                                    <b>Balanced Diet</b>
                                </h2>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/diet_plan.jpeg")} alt="Balanced Diet" />
                                    </div>
                                </div>
                                <div className='padding_img'></div>
                                <p>
                                    <b>
                                        Nutritionally adequate diet should be consumed through a wise
                                        choice from a variety of foods.
                                    </b>
                                </p>
                                <ul className="listUnstyle">
                                    <li>Nutrition is a basic prerequisite to sustain life.</li>
                                    <li>
                                        Variety in food is not only the spice of life but also the essence
                                        of nutrition and health.
                                    </li>
                                    <li>
                                        A diet consisting of several food groups provides all the required
                                        nutrients in proper amounts.
                                    </li>
                                    <li>
                                        Cereals, millets and pulses are major sources of most nutrients.
                                    </li>
                                    <li>
                                        Milk which provides good quality proteins and calcium must be an
                                        essential item of the diet, particularly for infants, children and
                                        women.
                                    </li>
                                    <li>
                                        Oils and nuts are calorie-rich foods, and are useful for
                                        increasing the energy density.
                                    </li>
                                    <li>
                                        Inclusion of eggs, flesh foods and fish enhances the quality of
                                        diet. However, vegetarians can derive almost all the nutrients on
                                        cereal/pulse/milk-based diets.
                                    </li>
                                    <li>
                                        Vegetables and fruits provide protective substances such as
                                        vitamins / minerals / phytonutrients.
                                    </li>
                                    <li>
                                        Choose a variety of foods in amounts appropriate for age, gender,
                                        physiological status and physical activity.
                                    </li>
                                    <li>
                                        Use a combination of whole grains, grams and greens. Include
                                        jaggery or sugar and cooking oils to bridge the calorie or energy
                                        gap.
                                    </li>
                                    <li>
                                        Prefer fresh, locally available vegetables and fruits in plenty.
                                    </li>
                                    <li>
                                        Include in the diets, foods of animal origin such as milk, eggs
                                        and meat, particularly for pregnant and lactating women and
                                        children.
                                    </li>
                                    <li>
                                        Adults should choose low-fat, protein-rich foods such as lean
                                        meat, fish, pulses and low-fat milk.
                                    </li>
                                    <li>
                                        Develop healthy eating habits and exercise regularly and move as
                                        much as you can to avoid sedentary lifestyle.
                                    </li>
                                </ul>
                            </div>:tab==2?
                            <div id="body_mass" className="nutrition_cont body_mass">
                                <h2>
                                    <b>Body Mass Index</b>
                                </h2>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/body_mass_index.png")} alt="Balanced Diet" />
                                    </div>
                                </div>
                                <div className='padding_img'></div>
                                <p>
                                    Body Mass Index (BMI) is a person’s weight in kilograms cate high
                                    body fatness. BMI screens for weight categories that may lead to
                                    health problems, but it does not diagnose the body fatness or health
                                    of an individual.
                                </p>
                            </div>:tab==3?
                            <div id="vitamin_mineral" className="nutrition_cont vitamin_mineral">
                                <h2>
                                    <b>Vitamins and Minerals</b>
                                </h2>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/Vitamins_Mineral.png")} alt="Vitamins_Mineral" />
                                    </div>
                                </div>
                                <div className='padding_img'></div>
                                <div className="rwd-table_wrp">
                                    <p>
                                        <b>Vitamins</b>
                                    </p>
                                    <p>
                                        A vitamin is an organic molecule (or a set of molecules closely
                                        related chemically, i.e. vitamers) that is an essential
                                        micronutrient which an organism needs in small quantities for the
                                        proper functioning of its metabolism.
                                    </p>
                                    <div className="table-responsive">
                                        <table className="rwd-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "10%" }}>Vitamins</th>
                                                    <th style={{ width: "45%" }}>Function</th>
                                                    <th style={{ width: "45%" }}>Sources</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* <tr>
                                  <td colspan="3">Vitamins</td>
                              </tr> */}
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Vitamin A</b>
                                                    </td>
                                                    <td data-th="Function works">
                                                        Helps form and maintain healthy teeth, bones, soft tissue,
                                                        mucoust, and skin.
                                                    </td>
                                                    <td data-th="Sources">
                                                        Fish in general, liver and dairy products;orange, ripe
                                                        yellow fruits, leafy vegetables, carrots, pumpkin, squash,
                                                        spinach
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Vitamin B1</b>
                                                    </td>
                                                    <td data-th="Function works">
                                                        Helps the body cells change carbohydrates into energy.
                                                        Getting enough carbohydrates is very important during
                                                        pregnancy and breastfeeding. It is also essential for
                                                        heart function and healthy nerve cells.
                                                    </td>
                                                    <td data-th="Sources">
                                                        Pork, wholemeal grains, brown rice, vegetables, potatoes,
                                                        liver, eggs
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Vitamin B2</b>
                                                    </td>
                                                    <td data-th="Function works">
                                                        Works with the other B vitamins. It is important for body
                                                        growth and the production of red blood cells.
                                                    </td>
                                                    <td data-th="Sources">
                                                        Dairy products, bananas, green beans, asparagus
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Vitamin B3</b>
                                                    </td>
                                                    <td data-th="Function works">
                                                        Niacin is a B vitamin that helps maintain healthy skin and
                                                        nerves. It also has cholesterol-lowering effects at higher
                                                        doses.
                                                    </td>
                                                    <td data-th="Sources">
                                                        Meat, ﬁsh, eggs, many vegetables, mushrooms, tree nuts
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Vitamin B5</b>
                                                    </td>
                                                    <td data-th="Function works">
                                                        Essential for the metabolism of food. It also plays a role
                                                        in the production of hormones and cholesterol.
                                                    </td>
                                                    <td data-th="Sources">Meat, broccoli, avocados</td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Vitamin B6</b>
                                                    </td>
                                                    <td data-th="Function works">
                                                        Helps form red blood cells and maintain brain function.
                                                        This vitamin also plays an important role in the proteins
                                                        that are part of many chemical reactions in the body. The
                                                        more protein you eat the more pyridoxine your body
                                                        requires.
                                                    </td>
                                                    <td data-th="Sources">
                                                        Meat, vegetables, tree nuts, bananas
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Vitamin B9</b>
                                                    </td>
                                                    <td data-th="Function works">
                                                        Folate works with vitamin B12 to help form red blood
                                                        cells. It is needed for the production of DNA, which
                                                        controls tissue growth and cell function. Any woman who is
                                                        pregnant should be sure to get enough folate. Low levels
                                                        of folate are linked to birth defects such as spina biﬁda.
                                                        Many foods are now fortiﬁed with folate in the form of
                                                        folic acid.
                                                    </td>
                                                    <td data-th="Sources">
                                                        Leafy vegetables, pasta, bread, cereal, liver
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Vitamin C</b>
                                                    </td>
                                                    <td data-th="Function works">
                                                        Ascorbic acid, is an antioxidant that promotes healthy
                                                        teeth and gums. It helps the body absorb iron and maintain
                                                        healthy tissue. It is also essential for wound healing.
                                                    </td>
                                                    <td data-th="Sources">Many fruits and vegetables, liver</td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Vitamin D</b>
                                                    </td>
                                                    <td data-th="Function works">
                                                        For strong bones, muscles and overall health.
                                                    </td>
                                                    <td data-th="Sources">
                                                        Eggs, liver, certain ﬁsh, certain mushroom
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Vitamin E</b>
                                                    </td>
                                                    <td data-th="Function works">
                                                        An antioxidant that protects red blood cells, muscle
                                                        cells, vitamin A and unsaturated fatty acids from
                                                        oxidation.
                                                    </td>
                                                    <td data-th="Sources">
                                                        Many fruits and vegetables, nuts and seeds, and seed oils
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Vitamin K</b>
                                                    </td>
                                                    <td data-th="Function works">
                                                        Needed to make prothrombin, important for blood clotting.
                                                        Vitamin K works with vitamin A to keep bones and teeth
                                                        healthy.
                                                    </td>
                                                    <td data-th="Sources">
                                                        Leafy green vegetables such as spinach; egg yolks; liver
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="rwd-table_wrp">
                                    <p>
                                        <b>Mineral</b>
                                    </p>
                                    <p>
                                        Mineral is a chemical element required as an essential nutrient by
                                        organisms to perform functions necessary for life.
                                    </p>
                                    <div className="table-responsive">
                                        <table className="rwd-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "20%" }}>Mineral</th>
                                                    <th style={{ width: "80%" }}>Sources</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Potassium</b>
                                                    </td>
                                                    <td data-th="Sources">
                                                        Sweet potato, tomato, potato, beans, lentils, dairy
                                                        products, seafood, banana, prune, carrot, orange
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Chlorine</b>
                                                    </td>
                                                    <td data-th="Sources">
                                                        Sodium chloride is the main dietary source.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Sodium</b>
                                                    </td>
                                                    <td data-th="Sources">
                                                        Sodium chloride, sea vegetables, milk and spinach
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Calcium</b>
                                                    </td>
                                                    <td data-th="Sources">
                                                        Dairy products, eggs canned ﬁsh with bone, green leafy
                                                        vegetables, nuts, seeds, tofu, thyme, oregano, dill,
                                                        cinnamon
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Phosphorus</b>
                                                    </td>
                                                    <td data-th="Sources">
                                                        Red meat, dairy foods, ﬁsh,poultry, bread, rice, oats.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Magnesium</b>
                                                    </td>
                                                    <td data-th="Sources">
                                                        Spinach,nuts, seeds, whole grains, peanuts butter,
                                                        avocado, legumes
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Iron</b>
                                                    </td>
                                                    <td data-th="Sources">
                                                        Meat, seafood, nuts, beans, dark chocolate
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Zinc</b>
                                                    </td>
                                                    <td data-th="Sources">
                                                        Oysters*, red meat, poultry, nuts, whole grains, dairy
                                                        products
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Manganese</b>
                                                    </td>
                                                    <td data-th="Sources">
                                                        Grains, legumes, seeds, nuts, leafy vegetables, tea,
                                                        coffee
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Copper</b>
                                                    </td>
                                                    <td data-th="Sources">
                                                        Liver, seafood, oysters, nuts, seeds; some: whole grains,
                                                        legumes
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td data-th="vitamin type">
                                                        <b>Iodine</b>
                                                    </td>
                                                    <td data-th="Sources">
                                                        Seaweed, grains, eggs, iodized salt
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>:
                            <div id="organs_cont" className="nutrition_cont organs_cont">
                                <h2>
                                    <b>Organs</b>
                                </h2>
                                <ul className="listUnstyle">
                                    <li>
                                        <b>Uterus</b>
                                    </li>
                                </ul>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/uters.png")} alt="Balanced Diet" />
                                    </div>
                                </div>
                                <div className='padding_img'></div>
                                <p>
                                    <b>Function : </b>It functions to nourish and house a fertilized egg
                                    until the fetus, or offspring, is ready to be delivered.
                                </p>
                                <p>
                                    <b>How to keep your uterus healthy?</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <b>Nuts and seeds</b>
                                    </li>
                                    <li>
                                        <p>
                                            Nuts such as almonds, cashews and walnuts, and seeds such as
                                            flaxseed are rich in omega-3 fatty acids and good cholesterol.
                                            These nutrients reduce the risk of uterine fibroids and reduce
                                            your risk of uterine cancer. They also ensure optimal birth
                                            weight for your baby.{" "}
                                        </p>
                                    </li>
                                </ul>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <b>Leafy vegetables</b>
                                    </li>
                                    <li>
                                        <p>
                                            Maintain an alkaline balance and provide vital nutrients such as
                                            minerals and folic acid that ensure optimal functioning.
                                        </p>
                                    </li>
                                </ul>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <b>Fresh fruits</b>
                                    </li>
                                    <li>
                                        <p>
                                            Fruits are rich in many essential nutrients such as vitamin C
                                            and flavonoids. These act as a natural fibroid treatment and
                                            even prevent the growth of fibroids in your uterus. Flavonoids
                                            help keep your reproductive system healthy and prevent ovarian
                                            cancer.
                                        </p>
                                    </li>
                                </ul>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <b>Lemons</b>
                                    </li>
                                    <li>
                                        <p>
                                            The benefits of having a glass of warm water with freshly
                                            squeezed lemon juice Lemons are rich in Vitamin C, which helps
                                            in increasing and maintaining the uterus’ immunity, preventing
                                            uterus infections.
                                        </p>
                                    </li>
                                </ul>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <b>Whole grains</b>
                                    </li>
                                    <li>
                                        <p>
                                            Whole grains are an excellent source of fiber, which helps
                                            control and prevent fibroid tumors. They keep your vitals
                                            healthy and help in their optimal functioning by flushing out
                                            the excess estrogen from the body.
                                        </p>
                                    </li>
                                </ul>
                                <hr />
                                <ul className="listUnstyle">
                                    <li>
                                        <b>Teeth</b>
                                    </li>
                                </ul>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/teeth.png")} alt="Balanced Diet" />
                                    </div>
                                </div>
                                <p>
                                    The human teeth function to mechanically break down items of food by
                                    cutting and crushing them in preparation for swallowing and
                                    digesting.
                                </p>
                                <b>Eat a more balanced diet</b>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>
                                            WholeCalcium-rich foods, such as low-fat or fat-free milk,
                                            yogurt and cheese, and fortified soymilk help promote strong
                                            teeth and bones. Other sources of calcium include tofu (made
                                            with calcium sulfate), canned salmon, almonds and some dark
                                            green leafy vegetables.
                                        </p>
                                    </li>
                                </ul>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>
                                            Phosphorus, a mineral found in eggs, fish, lean meat, dairy,
                                            nuts and beans is good for strong teeth.
                                        </p>
                                    </li>
                                </ul>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>
                                            Vitamin C promotes gum health, so eat plenty of sources,
                                            including citrus fruits, tomatoes, peppers, broccoli, potatoes
                                            and spinach.
                                        </p>
                                    </li>
                                </ul>
                                <hr />
                                <ul className="listUnstyle">
                                    <li>
                                        <b>Eye</b>
                                    </li>
                                </ul>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/eye.png")} alt="Balanced Diet" />
                                    </div>
                                </div>
                                <p>
                                    The human eye is a sense organ, part of the sensory nervous system,
                                    that reacts to visible light and allows us to use visual information
                                    for various purposes including seeing things, keeping our balance,
                                    and maintaining circadian rhythm.
                                </p>
                                <p>
                                    Nutrients like omega-3 fatty acids, lutein, zinc, and vitamins C and
                                    E might help ward off age-related vision problems like macular
                                    degeneration and cataracts.{" "}
                                </p>
                                <b>To get them, fill your plate with:</b>
                                <ol className="listUnstyle nutri_ol">
                                    <li>
                                        Green leafy vegetables like spinach, kale, and collards Salmon,
                                        tuna, and other oily fish Eggs, nuts, beans, and other nonmeat
                                        protein sources Oranges and other citrus fruits or juices Oysters
                                        and pork
                                    </li>
                                    <li>Quit Smoking</li>
                                    <li>Wear Sunglasses</li>
                                    <li>Use Safety Eyewear</li>
                                    <li>Look Away From the Computer Screen</li>
                                    <li>Visit Your Eye Doctor Regularly</li>
                                </ol>
                                <hr />
                                <ul className="listUnstyle">
                                    <li>
                                        <b>Hair</b>
                                    </li>
                                </ul>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/hair.png")} alt="Hair" />
                                    </div>
                                </div>
                                <p>
                                    <b>How to keep your hairs healthy ?</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <b>Eat healthy</b>
                                    </li>
                                    <li>
                                        <p>
                                            Make sure your diet includes plenty of proteins, biotin,
                                            vitamins and essential fatty acids to keep hair healthy, strong
                                            and lustrous.
                                        </p>
                                    </li>
                                </ul>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <b>Avoid very hot or cold showers</b>
                                    </li>
                                    <li>
                                        <p>
                                            Extreme water temperatures can make your hair weak and vulnerable to damage.
                                        </p>
                                    </li>
                                </ul>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <b>Don't comb hair when it is wet</b>
                                    </li>
                                    <li>
                                        <p>
                                            Your hair is fragile when it's wet, combing hair in this state
                                            will result in breakage and hair fall.
                                        </p>
                                    </li>
                                </ul>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <b>Exercise often</b>
                                    </li>
                                    <li>
                                        <p>
                                            Stay active and exercise regularly to ensure good blood
                                            circulation throughout the body.
                                        </p>
                                    </li>
                                </ul>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <b>Sleep well</b>
                                    </li>
                                    <li>
                                        <p>
                                            Stress is one of the leading causes of hair fall, therefore it
                                            is necessary to relax and sleep well.
                                        </p>
                                    </li>
                                </ul>
                                <hr />
                                <ul className="listUnstyle">
                                    <li>
                                        <b>Liver</b>
                                    </li>
                                </ul>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/liver.png")} alt="Liver" />
                                    </div>
                                </div>
                                <p>
                                    The liver regulates most chemical levels in the blood and excretes a
                                    product called bile. This helps carry away waste products from the
                                    liver.
                                </p>
                                <p>
                                    <b>Ways to a Healthy Liver</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>Maintain a healthy weight.</p>
                                    </li>
                                    <li>
                                        <p>Eat a balanced diet.</p>
                                    </li>
                                    <li>
                                        <p>Exercise regularly.</p>
                                    </li>
                                    <li>
                                        <p>Avoid toxins.</p>
                                    </li>
                                    <li>
                                        <p>Use alcohol responsibly.</p>
                                    </li>
                                    <li>
                                        <p>Avoid the use of illicit drugs.</p>
                                    </li>
                                    <li>
                                        <p>Get medical care if you're exposed to blood.</p>
                                    </li>
                                    <li>
                                        <p>Don’t share personal hygiene items.</p>
                                    </li>
                                    <li>
                                        <p>Practice safe sex.</p>
                                    </li>
                                    <li>
                                        <p>Wash your hands.</p>
                                    </li>
                                    <li>
                                        <p>
                                            Flush out with plenty of water intake: Water is the best
                                            flushing agent. It flushes your liver and kidney when taken
                                            optimally
                                        </p>
                                    </li>
                                    <li>
                                        <p>Don’t share personal hygiene items</p>
                                    </li>
                                </ul>
                                <p>
                                    <b>Food that cleanses liver</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>Garlic</p>
                                    </li>
                                    <li>
                                        <p>Citrus fruits</p>
                                    </li>
                                    <li>
                                        <p>Turmeric root</p>
                                    </li>
                                    <li>
                                        <p>Leafy Green Vegetables</p>
                                    </li>
                                    <li>
                                        <p>Apples</p>
                                    </li>
                                    <li>
                                        <p>Green Tea</p>
                                    </li>
                                    <li>
                                        <p>Beetroots &amp; Carrots</p>
                                    </li>
                                    <li>
                                        <p>Walnuts</p>
                                    </li>
                                    <li>
                                        <p>Lentils</p>
                                    </li>
                                    <li>
                                        <p>Avocados</p>
                                    </li>
                                    <li>
                                        <p>Tomato</p>
                                    </li>
                                    <li>
                                        <p>Plants and infusions</p>
                                    </li>
                                    <li>
                                        <p>Curcuma and other spices</p>
                                    </li>
                                    <li>
                                        <p>Quinoa</p>
                                    </li>
                                </ul>
                                <hr />
                                <ul className="listUnstyle">
                                    <li>
                                        <b>Pancreas</b>
                                    </li>
                                </ul>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/pancreas.png")} alt="Pancreas" />
                                    </div>
                                </div>
                                <p>
                                    Pancreas is an organ of the digestive system and endocrine system of
                                    vertebrates.
                                </p>
                                <p>
                                    The pancreas is involved in blood sugar control and metabolism
                                    within the body, and also in the secretion of substances
                                    (collectively pancreatic juice) that help digestion.
                                </p>
                                <p>
                                    Rich in protein, low in animal fats, and contain antioxidants. Try
                                    lean meats, beans and lentils, clear soups, and dairy alternatives
                                    (such as flax milk and almond milk). Your pancreas won’t have to
                                    work as hard to process these.
                                </p>
                                <p>Spinach, blueberries, cherries, and whole grains</p>
                                <hr />
                                <ul className="listUnstyle">
                                    <li>
                                        <b>Kidney</b>
                                    </li>
                                </ul>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/kidney.png")} alt="Kidney" />
                                    </div>
                                </div>
                                <p>
                                    <b>Kidney and its Function</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>Removal of waste products.</p>
                                    </li>
                                    <li>
                                        <p>Removal of excess fluid.</p>
                                    </li>
                                    <li>
                                        <p>Balance minerals and chemicals.</p>
                                    </li>
                                    <li>
                                        <p>Control of blood pressure.</p>
                                    </li>
                                    <li>
                                        <p>Red blood cells production.</p>
                                    </li>
                                    <li>
                                        <p>To maintain healthy bones.</p>
                                    </li>
                                    <li>
                                        <p>Production of certain hormones.</p>
                                    </li>
                                </ul>
                                <p>
                                    <b>What foods are good for kidneys?</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>Water intake- to excrete waste products</p>
                                    </li>
                                    <li>
                                        <p>
                                            Fatty fish- which contains omega3 fatty acid which reduces fat
                                            level in blood
                                        </p>
                                    </li>
                                    <li>
                                        <p>Berries- which contains Antioxidants</p>
                                    </li>
                                    <li>
                                        <p>Apple- contains fibers</p>
                                    </li>
                                </ul>
                                <hr />
                                <ul className="listUnstyle">
                                    <li>
                                        <b>Bones</b>
                                    </li>
                                </ul>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/bones.png")} alt="bones" />
                                    </div>
                                </div>
                                <p>
                                    <b>The functions of bones:</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>Supporting your body and helping you move.</p>
                                    </li>
                                    <li>
                                        <p>
                                            Provides the medium—marrow for the development and storage of
                                            bloodcells.
                                        </p>
                                    </li>
                                    <li>
                                        <p>Protecting your internal organs.</p>
                                    </li>
                                    <li>
                                        <p>Producing your blood cells.</p>
                                    </li>
                                    <li>
                                        <p>Storing and releasing fat.</p>
                                    </li>
                                    <li>
                                        <p>Storing and releasing minerals.</p>
                                    </li>
                                </ul>
                                <p>
                                    <b>which diet should follow to keep bones healthy.</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>
                                            Dairy products such as low-fat and non-fat milk, yogurt and
                                            cheese Eggs, tuna, salmon(type of fatty fish) which is rich source
                                            of vitamin D Potassium, vitamin K and magnesium help your body
                                            absorb and use calcium. foods like vegetables and fruit, legumes
                                            (beans, peas, lentils), nuts, seeds, whole grains, and fish are
                                            rich in these.
                                        </p>
                                    </li>
                                </ul>
                                <hr />
                                <ul className="listUnstyle">
                                    <li>
                                        <b>Lung</b>
                                    </li>
                                </ul>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/lungs.png")} alt="lungs" />
                                    </div>
                                </div>
                                <p>
                                    One of a pair of organs in the chest that supplies the body with
                                    oxygen, and removes carbon dioxide from the body
                                </p>
                                <p>
                                    <b>Here are some ways to keep your lungs healthy:</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>Don't Smoke.</p>
                                    </li>
                                    <li>
                                        <p>
                                            Avoid Exposure to Indoor Pollutants That Can Damage Your Lungs.
                                        </p>
                                    </li>
                                    <li>
                                        <p>Minimize Exposure to Outdoor Air Pollution.</p>
                                    </li>
                                    <li>
                                        <p>Prevent Infection.</p>
                                    </li>
                                    <li>
                                        <p>Get Regular Check-ups.</p>
                                    </li>
                                    <li>
                                        <p>Exercise.</p>
                                    </li>
                                </ul>
                                <p>
                                    <b>Best 5 food for lung</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>Ginger</p>
                                    </li>
                                    <li>
                                        <p>Carom Seeds</p>
                                    </li>
                                    <li>
                                        <p>Tulsi</p>
                                    </li>
                                    <li>
                                        <p>Pippali</p>
                                    </li>
                                    <li>
                                        <p>Trifala/Triphala</p>
                                    </li>
                                </ul>
                                <p>
                                    Aerobic activities like walking, running or jumping rope give your
                                    heart and lungs the kind of workout they need to function
                                    efficiently. Musclestrengthening activities like weight-lifting or
                                    Pilates build core strength, improving your posture, and toning your
                                    breathing muscles.
                                </p>
                                <hr />
                                <ul className="listUnstyle">
                                    <li>
                                        <b>Skin</b>
                                    </li>
                                </ul>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/skin.png")} alt="skin" />
                                    </div>
                                </div>
                                <p>
                                    The skin is the body's largest organ, made of water, protein, fats
                                    and minerals. Your skin protects your body from germs and regulates
                                    body temperature. Nerves in the skin help you feel sensations like
                                    hot and cold.
                                </p>
                                <p>
                                    <b>How to keep skin healthy and clear:</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>Avoid popping pimples</p>
                                    </li>
                                    <li>
                                        <p>Avoid touching the face</p>
                                    </li>
                                    <li>
                                        <p>Moisturize</p>
                                    </li>
                                    <li>
                                        <p>Always wear sunscreen</p>
                                    </li>
                                    <li>
                                        <p>Focus on gentle products</p>
                                    </li>
                                    <li>
                                        <p>Avoid hot water</p>
                                    </li>
                                    <li>
                                        <p>Use gentle cleansing devices</p>
                                    </li>
                                    <li>
                                        <p>Stay hydrated</p>
                                    </li>
                                    <li>
                                        <p>Eat a healthful diet</p>
                                    </li>
                                    <li>
                                        <p>Lifestyle changes</p>
                                    </li>
                                    <li>
                                        <p>Reduce stress</p>
                                    </li>
                                </ul>
                                <p>
                                    <b>Vitamins essential for skin</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>
                                            <b>Vitamin D</b>
                                        </p>
                                        <p>
                                            vitamin produced by the sun that may help skin tone and
                                            psoriasis.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Vitamin C</b>
                                        </p>
                                        <p>
                                            vitamin that may prevent aging, reduce wrinkles, and help dry
                                            skin.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Vitamin E</b>
                                        </p>
                                        <p>An antioxidant that may help protect against sun damage.</p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Vitamin K</b>
                                        </p>
                                        <p>
                                            An essential vitamin used to treat stretch marks, scars, and
                                            more.
                                        </p>
                                    </li>
                                </ul>
                                <hr />
                                <ul className="listUnstyle">
                                    <li>
                                        <b>Stomach</b>
                                    </li>
                                </ul>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/stomach.png")} alt="Stomach" />
                                    </div>
                                </div>
                                <p>
                                    The stomach has a dilated structure and functions as a vital
                                    digestive organ. In the digestive system the stomach is involved in
                                    the second phase of digestion, following chewing.
                                </p>
                                <p>
                                    Ginger is a plant that can reduce bloating and other digestive
                                    problems.
                                </p>
                                <p>
                                    This type of fat helps the body absorb vitamins. It also combines
                                    with fiber to help encourage bowel movements.
                                </p>
                                <p>
                                    Plant oils such as olive oil are a good source of unsaturated
                                    fats. Vegetables are rich in fiber, which is an important nutrient
                                    for digestion. Fiber stimulates the bowels to move stool out of the
                                    body.
                                </p>
                                <p>
                                    Many fruits are also rich in fiber. They also contain vitamins and
                                    minerals that are good for digestion, such as vitamin C and
                                    potassium like apples, oranges, and bananas.
                                </p>
                                <p>
                                    Whole-grain foods also have a high fiber content that aids digestion
                                    like brown rice and quinoa.
                                </p>
                                <p>
                                    Kefir is a fermented milk drink that is filling and contains
                                    probiotics.
                                </p>
                                <p>
                                    Leafy green vegetables are packed with nutrients that are helpful
                                    for digestion.
                                </p>
                                <hr />
                                <ul className="listUnstyle">
                                    <li>
                                        <b>Muscle</b>
                                    </li>
                                </ul>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/muscle.png")} alt="muscle" />
                                    </div>
                                </div>
                                <p>
                                    You have more than 600 muscles in your body. Different types of
                                    muscles have different jobs. Some muscles help you run, jump or
                                    perform delicate tasks like threading a needle.
                                </p>
                                <p>
                                    <b>The main functions of the muscular system are:</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>Fine movement involves writing,.speaking, facial expressions.</p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Mobility </b> Walking, running, swimming etc.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Stability </b>Muscle tendons stretch over joints and
                                            contribute to joint stability.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Posture </b> Help keep the body in the correct position when
                                            someone is sitting or standing.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Circulation </b> Heart is a muscle that pumps blood
                                            throughout the body.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Respiration </b> Breathing involves the use of the diaphragm
                                            muscle.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Digestion </b> Smooth muscles in the gastrointestinal or GI
                                            tract control digestion.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Urination </b> To hold and release urine from the bladder.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Childbirth </b>Smooth muscles in the uterus expand and
                                            contract during childbirth. These movements push the baby
                                            through the vagina
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Vision </b>Six skeletal muscles around the eye controls its
                                            movements.
                                        </p>
                                    </li>
                                    <li>
                                        <p>It maintain a stable image.</p>
                                    </li>
                                    <li>
                                        <p>scan the surrounding area.</p>
                                    </li>
                                    <li>
                                        <p>track moving objects.</p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Organ protection </b> Muscles in the torso protect the
                                            internal organs at the front, sides, and back of the body.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Temperature regulation </b> When body heat falls below
                                            optimal levels, the skeletal muscles increase their activity to make heat. Eg.Shivering
                                        </p>
                                    </li>
                                </ul>
                                <p>
                                    <b>DEIT FOR HEALTHY MUSCLES:</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>
                                            Includes protein from lean meats, poultry, seafood, beans, eggs,
                                            and nuts.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Whole grains, fruits, and vegetables in your diet for
                                            carbohydrates.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Unsaturated fats like walnuts, flaxseed, fish oils, peanut oil,
                                            and olive oil.
                                        </p>
                                    </li>
                                </ul>
                                <p>
                                    <b>To keep your muscles healthy and strong:</b>
                                </p>
                                <ul className="listUnstyle full_wdth_li nutri_que_ans">
                                    <li>
                                        <p>A High-Protein Diet.</p>
                                    </li>
                                    <li>
                                        <p>Quality Supplements.</p>
                                    </li>
                                    <li>
                                        <p>Resistance Training.</p>
                                    </li>
                                    <li>
                                        <p>An Active Lifestyle.</p>
                                    </li>
                                    <li>
                                        <p>Healthy Bones.</p>
                                    </li>
                                    <li>
                                        <p>Hormonal Balance.</p>
                                    </li>
                                    <li>
                                        <p>Anti-Inflammatory Foods.</p>
                                    </li>
                                    <li>
                                        <p>Cutting Back on Alcohol.</p>
                                    </li>
                                </ul>
                                <hr />
                                <ul className="listUnstyle">
                                    <li>
                                        <b>Gland</b>
                                    </li>
                                </ul>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../img/gland.png")} alt="gland" />
                                    </div>
                                </div>
                                <p>
                                    A gland is an organ which produces and releases substances that
                                    perform a specific function in the body. There are two types of
                                    gland. Endocrine glands are ductless glands and release the
                                    substances that they make (hormones) directly into the bloodstream.
                                </p>
                                <b>To help keep your endocrine system healthy:</b>
                                <ol className="listUnstyle nutri_ol">
                                    <li>Get plenty of exercise</li>
                                    <li>Eat a nutritious diet.</li>
                                    <li>Go for regular medical checkups.</li>
                                    <li>
                                        Talk to the doctor before taking any supplements or herbal
                                        treatments.
                                    </li>
                                    <li>
                                        Let the doctor know about any family history of endocrine
                                        problems, such as diabetes or thyroid problems.
                                    </li>
                                </ol>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>

        </PageWrapper>

    );
}

export default NutritionAndWellness;